import { forwardRef, memo } from "react"
import { IconPhotoOutline18 as ImageIcon } from "nucleo-ui-outline-18"

import type { ChangelogVersion } from "@productlane/zero"

import { DefaultEditor } from "@/components/editor/default-editor"
import { ChangelogCover, ChangelogCoverVideo } from "./changelog-cover"

interface ChangelogPreviewProps {
	version: ChangelogVersion
	blurhash?: string | null
}

export const ChangelogPreview = memo(
	forwardRef<HTMLDivElement, ChangelogPreviewProps>(
		({ version, blurhash }, ref) => {
			return (
				<div
					className="flex w-full flex-col items-center py-5 sm:py-10"
					ref={ref}
				>
					<div className="flex w-full flex-col items-center">
						<div className="mb-4 flex w-full max-w-[630px] items-center justify-end gap-2">
							<div className="w-full bg-transparent text-[36px] font-bold leading-[1.15] text-gray-900 dark:text-gray-100">
								{version.title || "Untitled"}
							</div>
						</div>
						<div className="w-full max-w-[630px] flex-1">
							{version.imageUrl ? (
								<div className="group relative">
									{version.coverVideoUrl ? (
										<ChangelogCoverVideo
											src={version.coverVideoUrl}
											poster={version.imageUrl}
										/>
									) : (
										<ChangelogCover
											src={version.imageUrl}
											blurhash={blurhash}
										/>
									)}
								</div>
							) : (
								<div className="flex h-[20.625rem] flex-col items-center justify-center rounded-lg border border-dashed border-gray-300 bg-gray-50 dark:border-gray-700 dark:bg-gray-800">
									<ImageIcon className="h-10 w-10 text-gray-400" />
									<p className="pt-2 text-sm text-gray-500 dark:text-gray-400">
										No cover image
									</p>
								</div>
							)}

							<DefaultEditor
								autofocus={false}
								initialContent={version.notes}
								placeholder=""
								onUpdate={() => {
									// Read-only, no updates
								}}
								editable={false}
								className="mt-8 min-h-[2rem] w-full max-w-none [&_.ProseMirror]:pb-8"
								key={version.id}
							/>
						</div>
					</div>
				</div>
			)
		},
	),
)

ChangelogPreview.displayName = "ChangelogPreview"
